export enum RequisitesInactiveStatusReason {
  Ping = 'ping',
  Blocked = 'blocked',
}
